import axiosInstance from 'src/common/axiosInstance';

const messageService = {

    index(conversationId, params = {}) {

        return axiosInstance.get(
            `/conversations/${conversationId}/messages`,
            {
                params,
            }
        );

    },

    show(conversationId, messageId) {

        return axiosInstance.get(
            `/conversations/${conversationId}/messages/${messageId}`
        );

    },

    create(conversationId, data) {

        return axiosInstance.post(
            `/conversations/${conversationId}/messages`,
            data
        );

    },

    update(conversationId, messageId, data) {

        return axiosInstance.put(
            `/conversations/${conversationId}/messages/${messageId}`,
            data
        );

    },

    destroy(conversationId, messageId) {

        return axiosInstance.delete(
            `/conversations/${conversationId}/messages/${messageId}`
        );

    },

    markAsRead(conversationId) {

        return axiosInstance.put(
            `/conversations/${conversationId}/messages/markAsRead`
        );

    },

};

export default messageService;